import { Injectable } from '@angular/core';
import { AttendeeSearchParams } from './attendee-search-params.model';
import { AttendeeSearchResult } from './attendee-search-result.model';
import { AttendedFlagOrUnflag } from './attended-flag-or-unflag.model';
import { AssignAttendeeTable } from './assign-attendee-table.model';
import { UpdateAttendeeCustomFields } from './update-attendee-custom-fields.model';
import { NavigationService } from 'src/app/shared/navigation/navigation.service';
import { EventsServiceApiService } from 'src/app/shared/api/events-service-api.service';
import { ApiService } from 'src/app/shared';

@Injectable({
  providedIn: 'root',
})
export class EventV4AttendeeService {
  private _eventServiceBaseUrl: string = '/event/v2/attendee/';

  public constructor(
    private _eventApiService: EventsServiceApiService,
    private _navigationService: NavigationService,
    private _monolithApi: ApiService
  ) {}

  public searchAttendees = (searchParams: AttendeeSearchParams): Promise<AttendeeSearchResult> => {
    let url = `${this._eventServiceBaseUrl}search`;
    return this._eventApiService.postPaged(url, searchParams).then((data: AttendeeSearchResult) => {
      return Promise.resolve(data);
    });
  };

  public exportAttendees = (eventId: number): Promise<string> => {
    let url = `${this._eventServiceBaseUrl}event/${eventId.toString()}/export`;
    return this._eventApiService.get(url);
  };

  public exportAttendeesExtended = (eventId: number): Promise<string> => {
    let url = `${this._eventServiceBaseUrl}event/${eventId.toString()}/export/extended`;
    return this._eventApiService.get(url);
  };

  public exportAttendeesExtendedAsExcel(eventId: number): Promise<string> {
    let url = `Event/${eventId}/Attendees/Export/Extended/Excel`;
    return this._monolithApi.get(url);
  }

  public exportAttendeesExtendedAndFiltered = (eventId: number, attendeeIds: Array<number>): Promise<string> => {
    let url = `${this._eventServiceBaseUrl}event/${eventId.toString()}/export/extended/filtered`;
    return this._eventApiService.post(url, attendeeIds);
  };

  public updateAttendedFlag = (attendeeIds: Array<number>, attended: boolean): Promise<void> => {
    let url = `${this._eventServiceBaseUrl}attended/${attended}`;
    return this._eventApiService.post(url, attendeeIds);
  };

  public updateAttendedFlagForEventItems = (dto: AttendedFlagOrUnflag): Promise<void> => {
    let url = this._eventServiceBaseUrl + 'event-items/attended-or-not';
    return this._eventApiService.post(url, dto);
  };

  public updateAttendedFlagForEventItemsByEvent = (eventId: number, dto: AttendedFlagOrUnflag): Promise<void> => {
    let url = `${this._eventServiceBaseUrl}event/${eventId}/event-items/attended-or-not`;
    return this._eventApiService.post(url, dto);
  };

  public getProfileIdsForAttendeeHeaderIds = (attendeeHeaderIds: Array<number>): Promise<Array<number>> => {
    let url = `${this._eventServiceBaseUrl}profile-ids`;
    return this._eventApiService.post(url, attendeeHeaderIds);
  };

  public getAttendeeHeaderIdsForEvent = (eventId: number, searchParams: AttendeeSearchParams): Promise<Array<number>> => {
    let url = `${this._eventServiceBaseUrl}event/${eventId.toString()}/AttendeeIds`;
    return this._eventApiService.post(url, searchParams);
  };

  public updateAttendeesCustomFields = (updateAttendeeCustomFields: UpdateAttendeeCustomFields): Promise<void> => {
    let url = `${this._eventServiceBaseUrl}custom-fields`;
    return this._eventApiService.post(url, updateAttendeeCustomFields);
  };

  public assignAttendeesToTable = (assignAttendeeTable: AssignAttendeeTable): Promise<void> => {
    let url = `${this._eventServiceBaseUrl}assign-table`;
    return this._eventApiService.post(url, assignAttendeeTable);
  };

  public printOpenInvoices = (eventId: number): void => {
    let url =
      this._navigationService.getLegacyDomain() +
      '/external/wcpages/v12/webclient/report/report.aspx?reportname=private_Events_NameBadge_Avery5383&recordselection=%7bEventList.EventID%7d+in+%5b' +
      eventId.toString() +
      '%5d';
    window.open(url);
  };
}
